/**
 * Configuration des thèmes disponibles
 */

export const THEMES = {
  'pe-main': {
    name: 'PE - Principal',
    description: 'Thème principal bleu',
    module: () => import('../themes/pe-main.js')
  },
  'pe-alt1': {
    name: 'PE - Alternatif 1',
    description: 'Thème violet',
    module: () => import('../themes/pe-alt1.js')
  },
  'pe-alt2': {
    name: 'PE - Alternatif 2',
    description: 'Thème cyan',
    module: () => import('../themes/pe-alt2.js')
  }
};

export const DEFAULT_THEME = 'pe-main';
